<template>
  <teleport to="body">
    <transition
      enter-active-class="transition-opacity duration-150"
      enter-from-class="opacity-0"
      leave-active-class="transition-opacity duration-150"
      leave-to-class="opacity-0"
    >
      <div
        v-if="item != null"
        ref="dialogRef"
        class="fixed inset-0 z-1050 flex items-center justify-center"
        role="dialog"
        aria-modal="true"
        tabindex="-1"
        :aria-labelledby="'modview__info-modal'"
        @keydown.escape="handleClose"
      >
        <!-- backdrop -->
        <div class="absolute inset-0 bg-onyx/80" @click="handleClose" />

        <!-- dialog -->
        <div
          class="relative bg-depth-1 rounded-lg shadow-xl w-full max-w-lg mx-4"
        >
          <!-- close button -->
          <button
            type="button"
            class="absolute top-2 right-2 p-1.5 rounded-md text-rhino hover:text-mouse transition-colors"
            aria-label="Close"
            @click="handleClose"
          >
            <fa-icon class="size-4" :icon="faTimes" aria-hidden="true" />
          </button>

          <!-- body -->
          <div class="p-6">
            <div class="flex">
              <landing-page-modview-grid-mod-icon :item="item" />
              <div class="relative ml-4 pr-8 grow">
                <b id="modview__info-modal">{{ item.name }}</b>
                <p class="text-brand mb-0">{{ recommendedRamSize }}</p>

                <landing-page-modview-grid-mod-tags
                  class="mt-2"
                  :tags="item.tags"
                />
              </div>
            </div>
            <p class="mb-0 mt-4">{{ item.description }}</p>
          </div>

          <!-- footer -->
          <div class="flex justify-center px-6 pb-6">
            <common-button
              :href="item.orderUrl"
              size="sm"
              block
              class="md:w-auto"
              data-testid="order-now-btn"
            >
              {{ $t('frontend/order-now') }}
            </common-button>
          </div>
        </div>
      </div>
    </transition>
  </teleport>
</template>

<script setup lang="ts">
import { faTimes } from '@fortawesome/pro-solid-svg-icons';
import type { StrapiMinecraftModpack } from '#variant/apollo/types/types';

const props = defineProps<{
  item?: StrapiMinecraftModpack | null;
}>();

const emit = defineEmits<{
  (e: 'modal-closed'): void;
}>();

const { t } = useI18n();

const recommendedRamSize = computed(() =>
  t('general/ram/units/recommended', {
    units:
      props.item?.unit === 'MB' ? props.item.memory / 1024 : props.item?.memory,
    unitName: 'GB',
  }),
);

const dialogRef = ref<HTMLElement | null>(null);

watch(
  () => props.item,
  async (val) => {
    if (val != null) {
      await nextTick();
      dialogRef.value?.focus();
    }
  },
);

const handleClose = () => {
  emit('modal-closed');
};
</script>
